import React from 'react';
import { Navigate } from 'react-router-dom';
import BusinessOverviewDashboard from '../features/business-overview/components/BusinessOverviewDashboard';
import { usePermissions } from '../features/permissions/PermissionsContext';
import {
  BUSINESS_OVERVIEW_VIEW_PERMISSION,
  getDefaultAppPath,
} from './defaultAppPath';

const AppIndexRoute: React.FC = () => {
  const { hasPermission } = usePermissions();

  if (hasPermission(BUSINESS_OVERVIEW_VIEW_PERMISSION)) {
    return <BusinessOverviewDashboard />;
  }

  return <Navigate to={getDefaultAppPath(hasPermission)} replace />;
};

export default AppIndexRoute;
